import { useEffect, useMemo } from 'react'
import type { CharacterIdQuery } from '../utils/characterIdQuery'
import {
    applyCharacterSharePayloadToStore,
    decodeCharacterSharePayload,
    type CharacterSharePayload,
} from '../utils/characterSharePayload'

export function useDecodedCharacterSharePayload(
    characterIdQuery: CharacterIdQuery,
): CharacterSharePayload | null {
    const payload = useMemo(() => {
        if (!characterIdQuery.isPresent) {
            return null
        }
        const raw = characterIdQuery.value.trim()
        if (!raw) {
            return null
        }
        return decodeCharacterSharePayload(raw)
    }, [characterIdQuery.isPresent, characterIdQuery.value])

    useEffect(() => {
        if (payload != null) {
            applyCharacterSharePayloadToStore(payload)
        }
    }, [payload])

    return payload
}
